import React, { useEffect } from 'react';
import style from '../../styling/general.module.scss';
import { Cross1Icon } from '@radix-ui/react-icons';

const LeaveModal = ({ closeModal }) => {

  useEffect(() => {
    const lock = () => {
      document.body.style.overflowY = 'hidden';
    }
    lock();

    return () => {
      document.body.style.overflowY = 'initial';
    }
  }, [])

  return (
    <div className={style.modalOverlay} onClick={() => closeModal()}>
      <div className={style.modal}>
        <Cross1Icon className={style.crossIcon} onClick={() => closeModal()} />
        <h1 className={style.modalTitle}>Afwezigheid Dr. Goossens</h1>
        <p style={{ fontSize: '22px' }}>
          Beste patiënten,<br/><br/>
          Dr. Goossens is afwezig van 1 juni 2026 tot en met 23 augustus 2026.<br/>
          Om de continuïteit en kwaliteit van zorg voor onze huidige patiënten te waarborgen, geldt gedurende deze periode een tijdelijke patiëntenstop.<br/><br/>
          Dank voor uw begrip.<br/>
          Huisartsenpraktijk 't Dorp
        </p>
      </div>
    </div>
  )
};

export default LeaveModal;
